import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import NavItemPositionModalButton from "../../visComponents/navigation/navItemPositionModalButton";
import {showerSideOptionsGroups, SIDE_POSITIONS} from "../../look/core/constants";
import {featureInterface} from "../../../interfaces/featureInterface";


const FeatureInfoAssociatedProductSideOptions = (props) => {

  const {activeFeature, parentOptionClick} = props;

  if (!activeFeature || !showerSideOptionsGroups.includes(activeFeature.partId)) {
    return null
  }

  const featureGroup = activeFeature.getParent();

  const leftDisabled = !featureGroup.layerPositions || (!featureGroup.layerPositions["L"] && !featureGroup.getMatchingPositionFeature("L", activeFeature));
  const rightDisabled = !featureGroup.layerPositions || (!featureGroup.layerPositions["R"] && !featureGroup.getMatchingPositionFeature("R", activeFeature));

  if (leftDisabled || rightDisabled) {
    return null
  }

  return (
    <div className="block">
      <div className="inline-block margin-t-8">
        <span className="nav-pos__title bold block">
          <FormattedMessage id="grohe.feature.placement"/>:
        </span>
        <div className="flex flex--start margin-t-8">
          {SIDE_POSITIONS.map((position, positionIndex) => {
            if (position === "C") { // no need for current groups
              return null
            }
            return (
              <div className={positionIndex ? "margin-l-16" : ""} key={positionIndex}>
                <NavItemPositionModalButton position={position}
                                            parent={featureGroup}
                                            updateCheckboxes={parentOptionClick}
                                            activeFeature={activeFeature}/>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
};

FeatureInfoAssociatedProductSideOptions.propTypes = {
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {canvasCount} = store.bathroomVisualizerState;
  return {
    canvasCount,
  };
};

export default injectIntl(
  connect(mapStateToProps)(FeatureInfoAssociatedProductSideOptions)
)
